import { render } from "./NavBar.vue?vue&type=template&id=514f79d1&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=514f79d1&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514f79d1"]])

export default __exports__